import yup from '@/libs/yup';

export default yup.object({
    persona: yup.object({}),
    actor: yup.object({})
});
